// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-u-up': IconArrowUUp;
    }
}

/**
 * The icon component for the 'arrowUUp' icon
 */
export class IconArrowUUp extends Icon {
    public constructor() {
        super(arrowUUp16X16);
    }
}

registerIcon('icon-arrow-u-up', IconArrowUUp);
export const iconArrowUUpTag = 'nimble-icon-arrow-u-up';
